import { BIRDVIEW_SECTION_ITEMS_LIMIT } from '../../DashboardBirdview.constants.api'

export const BIRDVIEW_TEAM_LOAD_PARAMS = {
  page_size: BIRDVIEW_SECTION_ITEMS_LIMIT,
}
